import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import {
  Brochure_eng,
  Brochure_spn,
  Download,
  stickers,
} from "../../../assets/assets";
import "./MarketMaterial.scss";
import * as Yup from "yup";
import MarketMaterialModal from "../../../Modal/Assets/MarketMaterialModal/MarketMaterialModal";
import toastr from "../../elements/toast";
const toastrService = new toastr(true);

const MarketMaterial = ({ tabactive }: any) => {
  const [showMarketMaterialModal, setShowMarketMaterialModal] = useState(false);
  let [marketingMaterialForm, setMarketingMaterialForm] = useState({
    brochures: 0,
    brochures_spanish: 0,
    stickers: 0,
  });

  const changeBrochureCount = (data: any) => {
    try {
      switch (data.value) {
        case "increment":
          setMarketingMaterialForm({
            ...marketingMaterialForm,
            brochures: marketingMaterialForm.brochures + 1,
          });
          return;
        case "decrement": {
          setMarketingMaterialForm({
            ...marketingMaterialForm,
            brochures: marketingMaterialForm.brochures - 1,
          });
          return;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const changeBrochuresSpanishCount = (data: any) => {
    try {
      switch (data.value) {
        case "increment":
          setMarketingMaterialForm({
            ...marketingMaterialForm,
            brochures_spanish: marketingMaterialForm.brochures_spanish + 1,
          });
          return;
        case "decrement": {
          setMarketingMaterialForm({
            ...marketingMaterialForm,
            brochures_spanish: marketingMaterialForm.brochures_spanish - 1,
          });
          return;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const changeStickersCount = (data: any) => {
    try {
      switch (data.value) {
        case "increment":
          setMarketingMaterialForm({
            ...marketingMaterialForm,
            stickers: marketingMaterialForm.stickers + 1,
          });
          return;
        case "decrement": {
          setMarketingMaterialForm({
            ...marketingMaterialForm,
            stickers: marketingMaterialForm.stickers - 1,
          });
          return;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkText = ({ event, type }: any) => {
    if (type == "brochures") {
      setMarketingMaterialForm({
        ...marketingMaterialForm,
        brochures: parseInt(event.target.value == "" ? 0 : event.target.value),
      });
    } else if (type == "brochures_spanish") {
      setMarketingMaterialForm({
        ...marketingMaterialForm,
        brochures_spanish: parseInt(
          event.target.value == "" ? 0 : event.target.value
        ),
      });
    } else {
      setMarketingMaterialForm({
        ...marketingMaterialForm,
        stickers: parseInt(event.target.value == "" ? 0 : event.target.value),
      });
    }
  };

  const handleSubmit = async (formData?: any) => {};

  const validationSchema = Yup.object({
    brochures: Yup.string().required("Please enter valid name."),
  });

  const OpenMarketMaterialModal = () => {
    if (
      !marketingMaterialForm.brochures &&
      !marketingMaterialForm.brochures_spanish &&
      !marketingMaterialForm.stickers
    ) {
      toastrService.showError("Please select atleast one item.");
      return false;
    }
    setShowMarketMaterialModal(true);
  };

  return (
    <>
      {tabactive == 2 && (
        <div className="market-material-class mt-md-5 animateView animated pb-4 pb-md-0">
          <div className="row h-100 align-items-center">
            <div className="col-12">
              <Formik
                onSubmit={handleSubmit}
                initialValues={marketingMaterialForm}
                validationSchema={validationSchema}
              >
                <Form>
                  <div className="row justify-content-between align-items-center">
                    <div className="w-100 col-12 pb-4 mt-5 mt-md-0">
                      <p className="materal-heading mb-0">
                        Order Your Marketing Material Today!
                      </p>
                    </div>

                    {/* <!-- card 1 English --> */}
                    <div className="col-lg-4 col-12 my-3">
                      <div className="card border_6 ">
                        <img
                          className="card-img-top p-4 card-img"
                          src={Brochure_eng}
                          alt="Brochure_eng"
                        />
                        <div className="materail-bottom">
                          <div className="broucher_text">
                            <p className="card-text pb-2 fs-16 font-weight-bold">
                              <span className="notranslate">Credee</span>
                              Brochure (English)
                            </p>
                          </div>
                          <div className="button_plus_minus d-flex align-items-center">
                            <span className="d-flex align-items-center ">
                              <button
                                className="minus"
                                onClick={() =>
                                  changeBrochureCount({
                                    control_name: "brochures",
                                    value: "decrement",
                                  })
                                }
                                disabled={marketingMaterialForm.brochures == 0}
                              >
                                -
                              </button>
                              <Field
                                type="number"
                                maxLength={4}
                                name="brochures"
                                value={marketingMaterialForm.brochures}
                                className="text-center bg-transparent border-0 w-25 mx-3  f-c-p-4 fs-16 input_count"
                                onChange={(event: any) =>
                                  checkText({ event, type: "brochures" })
                                }
                              />

                              <button
                                disabled={
                                  marketingMaterialForm.brochures >= 9999
                                }
                                className="add"
                                onClick={() =>
                                  changeBrochureCount({
                                    control_name: "brochures",
                                    value: "increment",
                                  })
                                }
                              >
                                +
                              </button>
                            </span>
                            {/* <span className="px-2 pointer">
                              <img src={Download} alt="" />
                            </span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <!-- card 2 spanish --> */}
                    <div className="col-lg-4 col-12 my-3">
                      <div className="card border_6 ">
                        <img
                          className="card-img-top p-4 card-img"
                          src={Brochure_spn}
                          alt="Brochure_spn"
                        />
                        <div className="materail-bottom">
                          <div className="broucher_text">
                            <p className="card-text pb-2 fs-16 font-weight-bold">
                              <span className="notranslate mb-2">Credee</span>{" "}
                              Brochure (Spanish)
                            </p>
                          </div>
                          <div className="button_plus_minus -pb-4 px-2 d-flex align-items-center justify-content-between">
                            <span className="d-flex align-items-center ">
                              <button
                                className="minus"
                                onClick={() =>
                                  changeBrochuresSpanishCount({
                                    control_name: "brochures_spanish",
                                    value: "decrement",
                                  })
                                }
                                disabled={
                                  marketingMaterialForm.brochures_spanish == 0
                                }
                              >
                                -
                              </button>
                              <Field
                                type="number"
                                maxLength={4}
                                name="brochures_spanish"
                                value={marketingMaterialForm.brochures_spanish}
                                className="text-center bg-transparent border-0 w-25 mx-3  f-c-p-4 fs-16 input_count"
                                onChange={(event: any) =>
                                  checkText({
                                    event,
                                    type: "brochures_spanish",
                                  })
                                }
                              />
                              <button
                                disabled={
                                  marketingMaterialForm.brochures_spanish >=
                                  9999
                                }
                                className="add"
                                onClick={() =>
                                  changeBrochuresSpanishCount({
                                    control_name: "brochures_spanish",
                                    value: "increment",
                                  })
                                }
                              >
                                +
                              </button>{" "}
                            </span>

                            {/* <span className="px-2 pointer">
                              <img src={Download} alt="" />
                            </span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <!-- card credee sticker --> */}
                    <div className="col-lg-4 col-12 my-3">
                      <div className="card border_6 ">
                        <img
                          className="card-img-top p-4 card-img"
                          src={stickers}
                          alt="stickers"
                        />
                        <div className="materail-bottom">
                          <div className="broucher_text">
                            <p className="card-text pb-2 fs-16 font-weight-bold">
                              <span className="notranslate">Credee</span>{" "}
                              Stickers
                            </p>
                          </div>
                          <div className="button_plus_minus -pb-4 px-2 d-flex align-items-center justify-content-between">
                            <span className="d-flex align-items-center justify-content-start flex-grow-1">
                              <button
                                className="minus"
                                onClick={() =>
                                  changeStickersCount({
                                    control_name: "stickers",
                                    value: "decrement",
                                  })
                                }
                                disabled={marketingMaterialForm.stickers == 0}
                              >
                                -
                              </button>
                              <Field
                                type="number"
                                maxLength={4}
                                name="stickers"
                                value={marketingMaterialForm.stickers}
                                className="text-center bg-transparent border-0 w-25 mx-3  f-c-p-4 fs-16 input_count"
                                onChange={(event: any) =>
                                  checkText({ event, type: "stickers" })
                                }
                              />
                              <button
                                disabled={
                                  marketingMaterialForm.stickers >= 9999
                                }
                                className="add"
                                onClick={() =>
                                  changeStickersCount({
                                    control_name: "stickers",
                                    value: "increment",
                                  })
                                }
                              >
                                +
                              </button>
                            </span>
                            {/* <span className="px-2 pointer">
                              <img src={Download} alt="" />
                            </span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className=" py-3 col-12">
                      <button
                        type="submit"
                        className="place"
                        onClick={() => {
                          OpenMarketMaterialModal();
                        }}
                      >
                        <span>Place Order</span>
                      </button>
                    </div>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      )}

      {showMarketMaterialModal && (
        <MarketMaterialModal
          show={showMarketMaterialModal}
          onHide={() => setShowMarketMaterialModal(false)}
          setbrochures={() => setMarketingMaterialForm(marketingMaterialForm)}
          brochures={marketingMaterialForm}
        />
      )}
    </>
  );
};

export default MarketMaterial;
